module.exports = __webpack_public_path__ + "static/media/emo-smile.9c563549.svg";